/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: y8010u5wSzea
import * as React from "react";
import {
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  useCurrentUser
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import * as plasmicAuth from "@plasmicapp/react-web/lib/auth";
import { usePlasmicDataSourceContext } from "@plasmicapp/data-sources-context";
import AppShell from "../../AppShell"; // plasmic-import: Vh273IDurq9t/component
import WebTab from "../../WebTab"; // plasmic-import: XNSjqwwbHvXu/component
import WebTopNav from "../../WebTopNav"; // plasmic-import: tGgk6oqzsXGR/component
import Breadcrumb from "../../Breadcrumb"; // plasmic-import: k0sjE64BjPfV/component
import ButtonSecondary from "../../ButtonSecondary"; // plasmic-import: yzRkzInaRral/component
import PageInTab2 from "../../PageInTab2"; // plasmic-import: JbFhS1uokEWY/component
import WebDock from "../../WebDock"; // plasmic-import: EtVLWfl2KEmA/component
import ButtonDock from "../../ButtonDock"; // plasmic-import: utQE8oqBBjiK/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicWebFiles.module.css"; // plasmic-import: y8010u5wSzea/css
import Icon30Icon from "./icons/PlasmicIcon__Icon30"; // plasmic-import: v-1PLPXOc6tO/icon
import Icon23Icon from "./icons/PlasmicIcon__Icon23"; // plasmic-import: YwlgzG5yARIP/icon
import Icon34Icon from "./icons/PlasmicIcon__Icon34"; // plasmic-import: 3VA-qZnm8pUB/icon
import Icon32Icon from "./icons/PlasmicIcon__Icon32"; // plasmic-import: dWHMt3F1tCmW/icon
import Icon33Icon from "./icons/PlasmicIcon__Icon33"; // plasmic-import: h408FMoSv0qx/icon
import Icon15Icon from "./icons/PlasmicIcon__Icon15"; // plasmic-import: KZeS8_m5UsgE/icon
import Icon27Icon from "./icons/PlasmicIcon__Icon27"; // plasmic-import: WzMsUn33Iqfb/icon
import Icon26Icon from "./icons/PlasmicIcon__Icon26"; // plasmic-import: flPWDcL8BgpD/icon

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    title: "o21p files.",
    openGraph: {
      title: "o21p files."
    },
    twitter: {
      card: "summary",
      title: "o21p files."
    }
  };
}

createPlasmicElementProxy;

export const PlasmicWebFiles__VariantProps = new Array();

export const PlasmicWebFiles__ArgProps = new Array();

const $$ = {};

function PlasmicWebFiles__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          styleTokensClassNames,
          sty.root
        )}
      >
        <AppShell
          data-plasmic-name={"appShell"}
          data-plasmic-override={overrides.appShell}
          appShell={
            <WebTab
              data-plasmic-name={"webTab"}
              data-plasmic-override={overrides.webTab}
              className={classNames("__wab_instance", sty.webTab)}
              tabContent={
                <PageInTab2
                  data-plasmic-name={"pageInTab2"}
                  data-plasmic-override={overrides.pageInTab2}
                  className={classNames("__wab_instance", sty.pageInTab2)}
                />
              }
              tabDock={
                <WebDock
                  data-plasmic-name={"webDock"}
                  data-plasmic-override={overrides.webDock}
                  className={classNames("__wab_instance", sty.webDock)}
                  modulesWrapper={
                    <React.Fragment>
                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__eySwQ
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__yLWgm
                            )}
                          >
                            <Icon30Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__bo5Sf
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebHomepage"] = true
                            ? (() => {
                                const actionArgs = { destination: `/` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebHomepage"] != null &&
                            typeof $steps["goToWebHomepage"] === "object" &&
                            typeof $steps["goToWebHomepage"].then === "function"
                          ) {
                            $steps["goToWebHomepage"] =
                              await $steps["goToWebHomepage"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__giqjb
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__sbwS
                            )}
                          >
                            <Icon23Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__tuuXe
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebRoadmap"] = true
                            ? (() => {
                                const actionArgs = { destination: `/roadmap` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebRoadmap"] != null &&
                            typeof $steps["goToWebRoadmap"] === "object" &&
                            typeof $steps["goToWebRoadmap"].then === "function"
                          ) {
                            $steps["goToWebRoadmap"] =
                              await $steps["goToWebRoadmap"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__y87S
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__tkAb7
                            )}
                          >
                            <Icon34Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__oyWkt
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebTheIndependent"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: `/the-independent`
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebTheIndependent"] != null &&
                            typeof $steps["goToWebTheIndependent"] ===
                              "object" &&
                            typeof $steps["goToWebTheIndependent"].then ===
                              "function"
                          ) {
                            $steps["goToWebTheIndependent"] =
                              await $steps["goToWebTheIndependent"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock___30Q4D
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__zOqK
                            )}
                          >
                            <Icon32Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__lTKbS
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebDemo"] = true
                            ? (() => {
                                const actionArgs = { destination: `/demo` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebDemo"] != null &&
                            typeof $steps["goToWebDemo"] === "object" &&
                            typeof $steps["goToWebDemo"].then === "function"
                          ) {
                            $steps["goToWebDemo"] = await $steps["goToWebDemo"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__o1AlZ
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__u2Htj
                            )}
                          >
                            <Icon33Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__opCfg
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebWorkspace"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: `/workspace`
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebWorkspace"] != null &&
                            typeof $steps["goToWebWorkspace"] === "object" &&
                            typeof $steps["goToWebWorkspace"].then ===
                              "function"
                          ) {
                            $steps["goToWebWorkspace"] =
                              await $steps["goToWebWorkspace"];
                          }
                        }}
                        status={"selected"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__kagdF
                        )}
                        color={"light"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__oeB7X
                            )}
                          >
                            <Icon15Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__sum8U
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebSupport"] = true
                            ? (() => {
                                const actionArgs = { destination: `/support` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebSupport"] != null &&
                            typeof $steps["goToWebSupport"] === "object" &&
                            typeof $steps["goToWebSupport"].then === "function"
                          ) {
                            $steps["goToWebSupport"] =
                              await $steps["goToWebSupport"];
                          }
                        }}
                        status={"_default"}
                      />

                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox___1AhYz
                        )}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__bhozS
                          )}
                        />
                      </div>
                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__t350R
                        )}
                        color={"dark"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__b7Cgg
                            )}
                          >
                            <Icon27Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__x3SHd
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebGallery"] = true
                            ? (() => {
                                const actionArgs = { destination: `/gallery` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebGallery"] != null &&
                            typeof $steps["goToWebGallery"] === "object" &&
                            typeof $steps["goToWebGallery"].then === "function"
                          ) {
                            $steps["goToWebGallery"] =
                              await $steps["goToWebGallery"];
                          }
                        }}
                        status={"_default"}
                      />

                      <ButtonDock
                        className={classNames(
                          "__wab_instance",
                          sty.buttonDock__lniZc
                        )}
                        color={"dark"}
                        iconTab={
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__a8K7R
                            )}
                          >
                            <Icon26Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg___2Utjc
                              )}
                              role={"img"}
                            />
                          </div>
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebPartnersCommunity"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: `/partners-community`
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebPartnersCommunity"] != null &&
                            typeof $steps["goToWebPartnersCommunity"] ===
                              "object" &&
                            typeof $steps["goToWebPartnersCommunity"].then ===
                              "function"
                          ) {
                            $steps["goToWebPartnersCommunity"] =
                              await $steps["goToWebPartnersCommunity"];
                          }
                        }}
                        status={"_default"}
                      />
                    </React.Fragment>
                  }
                />
              }
              tabNav={
                <WebTopNav
                  data-plasmic-name={"webTopNav"}
                  data-plasmic-override={overrides.webTopNav}
                  className={classNames("__wab_instance", sty.webTopNav)}
                  pageButtons={
                    <React.Fragment>
                      <ButtonSecondary
                        className={classNames(
                          "__wab_instance",
                          sty.buttonSecondary__uTgRj
                        )}
                        color={"tertiary"}
                        content={"link button"}
                        onClick={async () => {
                          const $steps = {};
                        }}
                      />

                      <ButtonSecondary
                        className={classNames(
                          "__wab_instance",
                          sty.buttonSecondary__yaJsa
                        )}
                        color={"primary"}
                        content={"x"}
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebWorkspace"] = true
                            ? (() => {
                                const actionArgs = {
                                  destination: `/workspace`
                                };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebWorkspace"] != null &&
                            typeof $steps["goToWebWorkspace"] === "object" &&
                            typeof $steps["goToWebWorkspace"].then ===
                              "function"
                          ) {
                            $steps["goToWebWorkspace"] =
                              await $steps["goToWebWorkspace"];
                          }
                        }}
                      />
                    </React.Fragment>
                  }
                  pageTitle={
                    <Breadcrumb
                      data-plasmic-name={"breadcrumb"}
                      data-plasmic-override={overrides.breadcrumb}
                      className={classNames("__wab_instance", sty.breadcrumb)}
                      crumb1={"files."}
                      crumb2={"the independent."}
                      crumbCount={"justTitle"}
                      sidePadding={"_default"}
                      size={"navS"}
                      tabTitle={"o21p files."}
                    />
                  }
                />
              }
            />
          }
          className={classNames("__wab_instance", sty.appShell)}
          layoutType={"_default"}
        />
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "appShell",
    "webTab",
    "webTopNav",
    "breadcrumb",
    "pageInTab2",
    "webDock"
  ],

  appShell: [
    "appShell",
    "webTab",
    "webTopNav",
    "breadcrumb",
    "pageInTab2",
    "webDock"
  ],

  webTab: ["webTab", "webTopNav", "breadcrumb", "pageInTab2", "webDock"],
  webTopNav: ["webTopNav", "breadcrumb"],
  breadcrumb: ["breadcrumb"],
  pageInTab2: ["pageInTab2"],
  webDock: ["webDock"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebFiles__ArgProps,
          internalVariantPropNames: PlasmicWebFiles__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebFiles__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicWebFiles";
  } else {
    func.displayName = `PlasmicWebFiles.${nodeName}`;
  }
  return func;
}

function withUsePlasmicAuth(WrappedComponent) {
  const WithUsePlasmicAuthComponent = props => {
    const dataSourceCtx = usePlasmicDataSourceContext() ?? {};
    const { isUserLoading, user, token } = plasmicAuth.usePlasmicAuth({
      appId: "fRuRbcdHVNMtdcnFK96ivt"
    });
    return (
      <PlasmicDataSourceContextProvider__
        value={{
          ...dataSourceCtx,
          isUserLoading,
          userAuthToken: token,
          user
        }}
      >
        <WrappedComponent {...props} />
      </PlasmicDataSourceContextProvider__>
    );
  };
  return WithUsePlasmicAuthComponent;
}

export const PlasmicWebFiles = Object.assign(
  // Top-level PlasmicWebFiles renders the root element
  withUsePlasmicAuth(makeNodeComponent("root")),
  {
    // Helper components rendering sub-elements
    appShell: makeNodeComponent("appShell"),
    webTab: makeNodeComponent("webTab"),
    webTopNav: makeNodeComponent("webTopNav"),
    breadcrumb: makeNodeComponent("breadcrumb"),
    pageInTab2: makeNodeComponent("pageInTab2"),
    webDock: makeNodeComponent("webDock"),
    // Metadata about props expected for PlasmicWebFiles
    internalVariantProps: PlasmicWebFiles__VariantProps,
    internalArgProps: PlasmicWebFiles__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/files",
      pagePath: "/files",
      params: {},
      query: {}
    })
  }
);

export default PlasmicWebFiles;
/* prettier-ignore-end */
